<template>
  <div id="promotions">
    <div class="promotions-list">
      <div class="promotions-item">
        <div class="promotions-title"></div>
        <router-link>Edit</router-link>
      </div>
    </div>
    <router-link :to="{ name: 'create-promotions' }" class="btn btn-primary">Add Promotions</router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
#promotions {
  .promotions-list {
    margin: 50px 0;

    .promotions-item {
      display: flex;

      .promotions-title {
        width: 50%;
      }
    }
  }
}
</style>
